import ActionTypes from "./constants";

export const initialState = {
  streamId: null,
  theaterId: null,
  userId: null,
  userName: null,
  creationTime: 0,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @typescript-eslint/default-param-last
const reducer = (state = initialState, action: any) => {
  const { payload } = action;

  switch (action.type) {
    case ActionTypes.UPDATE_FOCUSED_SCREEN_NOTIFICATION:
      return {
        ...state,
        ...payload,
      };
    case ActionTypes.RESET:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
